<template>
  <h4 class="title is-4">Monthly Income Sources</h4>
  <p>
    Use this section for your typical monthly income. Note that if you're
    planning to leave your job, you might want to remove your current salary to
    see what the future will look like.
  </p>
  <IncomeItems
    v-bind:income_items="income_items"
    v-bind:total_income="total_income"
    @del-inc="deleteInc"
  />
</template>

<script>
import IncomeItems from "./IncomeItems.vue";

export default {
  name: "Income",
  components: {
    IncomeItems,
  },
  props: {
    income_items: Array,
    total_income: Number,
  },
  data() {
    return {};
  },
  methods: {
    deleteInc(id) {
      this.$emit("del-inc", id);
    },
  },
};
</script>

<style>
</style>